import MobileDialog from "@app/analytics/MeetingReport/components/MobileDialog";

import SpeakerFilters from "./SpeakerFilters";

const TranscriptFiltersDialog = () => {
  return (
    <MobileDialog id="transcript_filters" title="Filter Transcript">
      <SpeakerFilters />
    </MobileDialog>
  );
};

export default TranscriptFiltersDialog;
